<template>
  <div>
    <slot name="label">
      <h2 class="mb-2 mb-lg-0">{{ $t('personalizedWalletCard.customize.photo.label') }}</h2>
      <h3 class="text-dark px-0">{{ $t('personalizedWalletCard.customize.photo.description') }}</h3>
    </slot>
    <div class="photo-selector-panel mt-3 pb-2">
      <b-row class="mt-3 mx-0 pb-3 pt-1 flex-nowrap scroll justify-content-start">
        <!-- Pet Photo Uploader -->
        <b-col class="px-0 mr-2 ml-1" cols="auto">
          <dp-image-cropper ref="image_cropper" :loading="loadingPetPhoto" @addToCard="addToCard" />
        </b-col>
        <b-col v-for="(image, key) in images" :key="key" cols="auto" class="px-2">
          <dp-base-avatar-image
            :key="key"
            :image="image"
            :class="{ selectedImage: selectedPhoto === image.id }"
            :loading="image.loading"
            @selectAvatar="selectAvatar"
          />
        </b-col>
        <dp-image-cropper ref="existing_image_cropper" :show-uploader="false" @base64Image="base64Image" />
      </b-row>
    </div>
    <ValidationProvider v-slot="{ errors }" vid="p-photo-select" :rules="{ required: { allowFalse: false } }" slim>
      <input id="photo-select-color" v-model="selectedPhoto" type="text" class="d-none" hidden />
      <span v-if="errors && errors[0]" class="text-danger">{{ $t('personalizedWalletCard.customize.photo.error') }}</span>
      <span v-else-if="uploadError" class="text-danger">{{ uploadError }}</span>
    </ValidationProvider>
  </div>
</template>

<script>
import { DpImageCropper, DpBaseAvatarImage, DpGetImageUtil } from '@docupet/component-library';
import { mapState } from 'vuex';
import { getBase64 } from '@/api/axios';

export default {
  name: 'WalletCardPhotoSelect',
  components: {
    DpImageCropper,
    DpBaseAvatarImage,
  },
  props: {
    images: {
      type: Array,
      required: true,
    },
    petId: {
      type: [String, Number],
      required: true,
    },
    photoPlaceholder: {
      type: String,
      required: false,
      default: null,
    },
  },
  data() {
    return {
      selectedPhoto: null,
      showCropper: true,
      uploadError: null,
    };
  },
  computed: {
    ...mapState({
      loadingPetPhoto: (state) => state.walletCardProduct.loadingPetPhoto,
    }),
  },
  methods: {
    DpGetImageUtil,
    getBase64,
    async addToCard(file, image) {
      try {
        this.uploadError = false;
        await this.$store.dispatch('walletCardProduct/uploadPetPhoto', {
          pet: this.petId,
          image: file,
        });
      } catch (err) {
        this.uploadError = err;
      } finally {
        this.$refs.image_cropper?.cancel();
        if (!this.uploadError) {
          this.base64Image(image, this.images[0]?.id);
        }
      }
    },
    base64Image(image, imageId, disableCrop = false) {
      this.selectedPhoto = imageId;
      this.$emit('selectedPhoto', image);
      if (this.showCropper && disableCrop) {
        this.$refs?.existing_image_cropper?.cancel();
      }
    },
    async selectAvatar(image, disableCrop = false) {
      this.uploadError = false;
      if (this.showCropper && !disableCrop) {
        try {
          const url = this.DpGetImageUtil(image?.original);
          const res = await this.getBase64(url);
          this.$refs?.existing_image_cropper?.imageToCrop(res, image.id);
        } catch (err) {
          this.uploadError = err;
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@docupet/component-library/src/assets/styles/_variables';
.selectedImage {
  ::v-deep .avatar-background {
    border: 4px solid $dp-blue;
  }
}
.photo-selector-panel {
  .scroll {
    scroll-snap-type: both proximity;
    overflow-x: auto;
    overflow-y: hidden;
    @media (min-width: 992px) {
      &::-webkit-scrollbar {
        background-color: $dp-gray-2;
        height: 0.75rem !important;
      }
      &::-webkit-scrollbar-thumb {
        background-color: $secondary;
        border-radius: 10px;
      }
    }
  }
}
</style>
